"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function Smoke(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M22.1 12c0 .55-.45 1-1 1h-7c-.55 0-1-.45-1-1s.45-1 1-1h7c.55 0 1 .45 1 1m0-3c0 .55-.45 1-1 1h-11c-.55 0-1-.45-1-1s.45-1 1-1h11c.55 0 1 .45 1 1m-4.967 8a3.043 3.043 0 0 1-2.883 2.1c-.57 0-1.117-.156-1.581-.449l-.666-.42-.565.549A4.335 4.335 0 0 1 8.4 20 4.405 4.405 0 0 1 4 15.6c0-.882.26-1.734.755-2.463l.364-.538-.343-.551A5.199 5.199 0 0 1 4 9.3C4 6.378 6.378 4 9.3 4c1.4 0 2.717.537 3.709 1.513l.382.287h.409c1.162 0 2.213.462 3 1.2h2.529a6.465 6.465 0 0 0-5.213-3.188A7.246 7.246 0 0 0 9.3 2C5.275 2 2 5.274 2 9.3c0 1.142.265 2.257.77 3.257A6.37 6.37 0 0 0 2 15.6C2 19.129 4.87 22 8.4 22a6.33 6.33 0 0 0 3.874-1.304 4.981 4.981 0 0 0 1.976.404c2.459 0 4.507-1.769 4.954-4.1h-2.071zm4.967-2c0 .55-.45 1-1 1h-9c-.55 0-1-.45-1-1s.45-1 1-1h9c.55 0 1 .45 1 1", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = Smoke;
